/**
 * Check if as a valid full name
 *
 * @param {string} name
 * @returns {boolean}
 */
export const validateFullName = (name: string | undefined): boolean => {
  if (!name) return false;

  const arrName = name.trim().split(' ');
  return arrName.length >= 2;
};
